import * as jsts from "jsts";
import {
  LineString,
  LinearRing,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Point,
  Polygon,
} from "ol/geom.js";

const OLParser = new jsts.io.OL3Parser();
(OLParser as any).inject(
  Point,
  LineString,
  LinearRing,
  Polygon,
  MultiPoint,
  MultiLineString,
  MultiPolygon
);

const OlExtent = (geom: jsts.geom.Geometry): number[] => {
  const envelope = geom.getEnvelopeInternal();
  return [
    envelope.getMinX(),
    envelope.getMinY(),
    envelope.getMaxX(),
    envelope.getMaxY(),
  ];
};

export { OLParser, OlExtent };
